// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3qPKy","col":"styles_col__3dGKc","fulfillmentStatus":"styles_fulfillmentStatus__2j195","emailCol":"styles_emailCol__1pNet"};